import React, {useState, useContext, useEffect} from 'react'
import LogoHrws from "../../img/logo-white.svg";
import { IoTicket } from "react-icons/io5";
import { Link, animateScroll as scroll } from "react-scroll";
import { slide as Menu } from 'react-burger-menu'
import LogoHuawey from '../../img/logo_huawey.png'
import LogoWiT from '../../img/logo_wit.png'
import LogoWomo from '../../img/womo_white.png'

function Header() {

    const [menuState, setMenuState] = useState()
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    var isMenuOpen = function(state) {
        return state.isOpen;
    };

    useEffect(() => {
        isMenuOpen === false ? setMenuState(true) : setMenuState(false)
    })

    function toggleMenu() {
        setMenuState(true)
    }

    return (
        <>
            <header className={offset >= 150 ? 'py-2 bg-[#AF00A9] fixed top-0 left-0 w-full z-40' : 'py-3 bg-[#2b3d87]/1 fixed top-0 left-0 w-full z-40'} style={{transition: '0.5s'}}>
                <div className="container max-w-screen-xl px-3 mx-auto flex justify-between items-center relative">

                    <div className={offset >= 500 ? "flex gap-4 justify-start items-center text-white max-md:mr-4 max-sm:hidden" : "flex gap-4 justify-start items-center text-white max-md:mr-4"}>
                        <a href="http://www.huawei.com/ua" target="_blank">
                            <img src={LogoHuawey} alt="Huawei"
                                 className="w-[100px]" />
                        </a>
                        /
                        <a href="https://womo.ua/" target="_blank">
                            <img src={LogoWomo} alt="Womo"
                                 className="w-[80px]" />
                        </a>
                        /
                        <a href="http://www.womenintech.com.ua" target="_blank">
                            <img src={LogoWiT} alt="Logo HRWS"
                                 className="w-[100px]" />
                        </a>
                    </div>

                    <div className="block lg:hidden">
                    <Menu onStateChange={isMenuOpen} isOpen={menuState} pageWrapId={"page-wrap"}>
                            <nav id="page-wrap">
                                <ul className="text-white">
                                    <li className="mb-3"><Link
                                        to="ebaut"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Про проєкт</Link>
                                    </li>
                                    <li className="mb-3"><Link
                                        to="speacers"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Спікери</Link>
                                    </li>
                                    <li className="mb-3"><Link
                                        to="programm"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Програма</Link>
                                    </li>

                                    {/*<li className="text-[#e7e9ec]"><Link*/}
                                    {/*    to="formats"*/}
                                    {/*    id="head_paketu_clk"*/}
                                    {/*    onClick={toggleMenu}*/}
                                    {/*    smooth={true}*/}
                                    {/*    offset={-70}*/}
                                    {/*    duration={500}>Формати участі</Link>*/}
                                    {/*</li>*/}
                                </ul>
                            </nav>
                        </Menu>
                    </div>


                    <nav className="hidden lg:block" id="page-wrap">
                        <ul className="gap-4 flex text-white">
                            <li><Link
                                to="ebaut"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Про проєкт</Link>
                            </li>
                            <li><Link
                                to="speacers"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Спікери</Link>
                            </li>
                            <li><Link
                                to="programm"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Програма</Link>
                            </li>

                            {/*<li><Link*/}
                            {/*    to="formats"*/}
                            {/*    id="head_paketu_clk"*/}
                            {/*    onClick={toggleMenu}*/}
                            {/*    smooth={true}*/}
                            {/*    offset={-70}*/}
                            {/*    duration={500}>Формати участі</Link>*/}
                            {/*</li>*/}
                        </ul>
                    </nav>

                    <Link to="top" spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          className={offset >= 500 ? "font-normal uppercase py-2 px-4 inline-flex items-center bg-[#8C98FF]" : "hidden"}>
                        <IoTicket className="font-bold text-2xl mr-2"/>
                        <div><span className="sm:inline hidden">Взяти</span> участь</div>
                    </Link>
                </div>

            </header>
        </>
    )
}

export default Header;